<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ServiceForm from './ServiceForm.vue';

const props = defineProps({
  service: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['close', 'submit']);
const { t } = useI18n();
const dialogRef = ref(null);
const isEdit = computed(() => Boolean(props.service?.id));
const title = computed(() =>
  isEdit.value
    ? t('ARROWS_AI.SERVICES.EDIT_TITLE')
    : t('ARROWS_AI.SERVICES.CREATE_TITLE')
);
const description = computed(() =>
  isEdit.value
    ? t('ARROWS_AI.SERVICES.EDIT_DESCRIPTION')
    : t('ARROWS_AI.SERVICES.CREATE_DESCRIPTION')
);

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="title"
    :description="description"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    @close="emit('close')"
  >
    <ServiceForm
      :service="service"
      :submit-label="isEdit ? t('ARROWS_AI.UPDATE') : t('ARROWS_AI.CREATE')"
      @submit="emit('submit', $event)"
      @cancel="dialogRef.close()"
    />
    <template #footer />
  </Dialog>
</template>
